import { Component, Input } from '@angular/core';

@Component({
    selector: "print-slide",
    templateUrl: 'print-slide.component.html'
})
export class PrintSlideComponent {
    @Input("meta") meta: any;
    constructor() {

    }
}


// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/carousel/slide/print-slide.component.ts